import { createSelector } from 'reselect';
import { getAll, CHECK_INS } from '../reducers';
import { CheckInInterface } from '@careapp/angular-sdk';

/**
 * Returns the checkins currently in the store, removing ones without a location.
 */
export const checkInsWithLocation = createSelector(getAll(CHECK_INS), state => {
  return (<Array<CheckInInterface>>state).filter(
    checkIn => checkIn.location !== null && checkIn.location !== undefined
  );
});
